// extracted by mini-css-extract-plugin
module.exports = {"container":"XxlPrimaryButton_container__UDDkb","selected":"XxlPrimaryButton_selected__3Xag4","label":"XxlPrimaryButton_label__3yJzk"};